import { submitToCrm } from "./utils/submitToCrm";
import { getUserIp } from "./utils/getUserIp";

var Webflow = Webflow || [];
Webflow.push(function () {
    // unbind webflow form handling (keep this if you only want to affect specific forms)
    $(document).off("submit");
    /* Any form on the page */
    $("form").submit(async function (e) {
        e.preventDefault();
        const $form = $(this); // The submitted form

        // Convert the array of objects into a single object
        const formDataArray = $form.serializeArray(); // Use .serializeArray() to get form data as an array of objects

        const formDataObj = {};
        $.each(formDataArray, function () {
            formDataObj[this.name] = this.value;
        });

        formDataObj.email = formDataObj.email.toLowerCase().trim();
        formDataObj.userIp = await getUserIp();
        formDataObj.submissionId = Date.now(); // Assign current timestamp in milliseconds as submissionId



        submitToCrm({ $form, formDataObj });
    });
});
